import React from 'react';
import LoadingSpinner from '../components/LoadingSpinner';

const UsersTab = ({
  users,
  loading,
  userSearchTerm,
  setUserSearchTerm,
  userSearchQuery,
  usersPagination,
  fetchUsers,
  onUserSearch,
  onClearUserSearch,
  onSearchKeyPress,
  onExportCSV,
  onShowCSVImport,
  onShowUserForm,
  onViewUserDashboard,
  onEditUser,
  formatDate
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Gerenciar Usuários</h2>
          <p className="text-gray-600">Visualize e gerencie usuários da plataforma</p>
        </div>
        <div className="flex space-x-4">
          <button
            onClick={onExportCSV}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            Exportar CSV
          </button>
          <button
            onClick={onShowCSVImport}
            className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
          >
            Importar CSV
          </button>
          <button
            onClick={onShowUserForm}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200"
          >
            Criar Usuário
          </button>
        </div>
      </div>

      {/* Search Filter */}
      <div className="mb-6">
        <div className="max-w-2xl">
          <label htmlFor="user-search" className="block text-sm font-medium text-gray-700 mb-2">
            Buscar usuários
          </label>
          <div className="flex space-x-2">
            <div className="flex-1 relative">
              <input
                type="text"
                id="user-search"
                value={userSearchTerm}
                onChange={(e) => setUserSearchTerm(e.target.value)}
                onKeyPress={onSearchKeyPress}
                placeholder="Digite nome, email ou empresa..."
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                <svg
                  className="w-5 h-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
            </div>
            <button
              onClick={onUserSearch}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              Aplicar
            </button>
            {userSearchTerm && (
              <button
                onClick={onClearUserSearch}
                className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg font-medium transition-colors duration-200 flex items-center"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                Limpar
              </button>
            )}
          </div>
          {userSearchQuery && (
            <p className="mt-2 text-sm text-blue-600">Buscando por: "{userSearchQuery}"</p>
          )}
        </div>
      </div>

      {loading ? (
        <LoadingSpinner message="Carregando usuários..." />
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Usuário
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Empresa
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Telefone
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Função
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Último Acesso
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Criado em
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {users.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="px-6 py-12 text-center text-gray-500">
                      <div className="flex flex-col items-center">
                        <svg
                          className="w-12 h-12 text-gray-400 mb-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                          />
                        </svg>
                        <p className="text-lg font-medium text-gray-900 mb-2">
                          {userSearchQuery
                            ? "Nenhum usuário encontrado para a busca"
                            : "Nenhum usuário encontrado"}
                        </p>
                        <p className="text-gray-500">
                          {userSearchQuery
                            ? "Tente ajustar os termos de busca"
                            : "Comece criando um novo usuário ou importando via CSV"}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  users.map((user) => (
                    <tr key={user.id}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-sm font-semibold">
                              {user.name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{user.name}</div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {user.email}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {user.company}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {user.whatsapp || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                            user.role === "admin"
                              ? "bg-red-100 text-red-800"
                              : "bg-blue-100 text-blue-800"
                          }`}
                        >
                          {user.role === "admin" ? "Admin" : "Usuário"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {formatDate(user.last_access)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {formatDate(user.created_at)}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        <div className="flex space-x-2">
                          <button
                            onClick={() => onViewUserDashboard(user)}
                            className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors duration-200"
                          >
                            Dashboard
                          </button>
                          <button
                            onClick={() => onEditUser(user)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors duration-200"
                          >
                            Editar
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls for Users */}
          {users.length > 0 && (
            <div className="px-6 py-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                  Mostrando {(usersPagination.current_page - 1) * usersPagination.per_page + 1} até{" "}
                  {Math.min(
                        usersPagination.current_page * usersPagination.per_page,
                        usersPagination.total
                  )} de {usersPagination.total} usuários
                  {userSearchQuery && ` (filtrado por "${userSearchQuery}")`}
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => {
                      if (typeof fetchUsers === 'function') {
                        fetchUsers(usersPagination.current_page - 1, userSearchQuery);
                      } else {
                        console.error('fetchUsers is not a function:', fetchUsers);
                      }
                    }}
                    disabled={!usersPagination.has_prev}
                    className={`px-3 py-1 rounded text-sm ${
                      usersPagination.has_prev
                        ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                        : "bg-gray-50 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Anterior
                  </button>

                  {/* Page numbers */}
                  {Array.from({ length: Math.min(5, usersPagination.total_pages) }, (_, i) => {
                    const startPage = Math.max(1, usersPagination.current_page - 2);
                    const pageNumber = startPage + i;
                    if (pageNumber <= usersPagination.total_pages) {
                      return (
                        <button
                          key={pageNumber}
                          onClick={() => {
                            if (typeof fetchUsers === 'function') {
                              fetchUsers(pageNumber, userSearchQuery);
                            } else {
                              console.error('fetchUsers is not a function:', fetchUsers);
                            }
                          }}
                          className={`px-3 py-1 rounded text-sm ${
                            pageNumber === usersPagination.current_page
                              ? "bg-blue-600 text-white"
                              : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                          }`}
                        >
                          {pageNumber}
                        </button>
                      );
                    }
                    return null;
                  })}

                  <button
                    onClick={() => {
                      if (typeof fetchUsers === 'function') {
                        fetchUsers(usersPagination.current_page + 1, userSearchQuery);
                      } else {
                        console.error('fetchUsers is not a function:', fetchUsers);
                      }
                    }}
                    disabled={!usersPagination.has_next}
                    className={`px-3 py-1 rounded text-sm ${
                      usersPagination.has_next
                        ? "bg-gray-100 hover:bg-gray-200 text-gray-700"
                        : "bg-gray-50 text-gray-400 cursor-not-allowed"
                    }`}
                  >
                    Próximo
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default UsersTab;
